export default __webpack_public_path__ + "static/media/Spain.6bdfac54.svg";